import type {
  ReservationSlotSettings,
  ReservationSlotSettingsInput,
} from '../../domain/reservationSlots';
import type { ReservationSlotSettingsRepository } from '../../application/reservationSlots/ports/ReservationSlotSettingsRepository';
import { reservationSlotApi, type SettingsApiResponse, type SettingsApiInput } from '../api/reservationSlotApi';

/**
 * APIレスポンス（snake_case）をドメイン型（camelCase）へ変換する
 */
function toDomain(res: SettingsApiResponse): ReservationSlotSettings {
  return {
    defaultTemplateId: res.default_template_id,
    overrides: res.overrides.map((o) => ({
      doctorId: o.doctor_id,
      doctorName: o.doctor_name,
      templateId: o.template_id,
    })),
  };
}

/**
 * 入力データ（camelCase）をAPIリクエストボディ（snake_case）へ変換する
 */
function toApiInput(input: ReservationSlotSettingsInput): SettingsApiInput {
  return {
    default_template_id: input.defaultTemplateId,
    overrides: input.overrides.map((o) => ({
      doctor_id: o.doctorId,
      template_id: o.templateId,
    })),
  };
}

/**
 * 解放枠 基本設定 Repository 具象実装
 *
 * @implements {ReservationSlotSettingsRepository}
 */
export class ReservationSlotSettingsRepositoryImpl implements ReservationSlotSettingsRepository {
  async get(): Promise<ReservationSlotSettings> {
    const res = await reservationSlotApi.getSettings();
    return toDomain(res);
  }

  async update(input: ReservationSlotSettingsInput): Promise<ReservationSlotSettings> {
    const res = await reservationSlotApi.updateSettings(toApiInput(input));
    return toDomain(res);
  }
}

export const reservationSlotSettingsRepository = new ReservationSlotSettingsRepositoryImpl();
